export enum RelationFileType {
    payout = 'payout',
}
